import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequest, handleDynamicRequestHeader, handleDynamicRequestHeaderMulter } from '../components/DyanamicRequest';

// Create a new sticker
export const createSticker = async (stickerData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    formData.append('sticker', stickerData.sticker);
    formData.append('title', stickerData.title);
    formData.append('type', stickerData.type);
    formData.append('category', stickerData.category);
    formData.append('tags', JSON.stringify(stickerData.tags));

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'POST',
      `${BASE_URL}/admin/stickers`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to create sticker' }),
      (response) => resolve(response)
    );
  });
};

// Get stickers with filters
export const getStickers = async (params = {}) => {
  return new Promise((resolve) => {
    const { limit = 10, offset = 0, category, tag } = params;
    let url = `${BASE_URL}/admin/stickers?limit=${limit}&offset=${offset}`;
    
    if (category) url += `&category=${category}`;
    if (tag) url += `&tag=${tag}`;

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeader(
      'GET',
      url,
      null,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to fetch stickers' }),
      (response) => resolve(response)
    );
  });
};

// Update a sticker
export const updateSticker = async (stickerId, stickerData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    
    if (stickerData.title) formData.append('title', stickerData.title);
    if (stickerData.sticker) formData.append('sticker', stickerData.sticker);
    if (stickerData.type) formData.append('type', stickerData.type);
    if (stickerData.category) formData.append('category', stickerData.category);
    if (stickerData.tags) formData.append('tags', JSON.stringify(stickerData.tags));

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'PUT',
      `${BASE_URL}/admin/stickers/${stickerId}`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to update sticker' }),
      (response) => resolve(response)
    );
  });
};

// Delete a sticker
export const deleteSticker = async (stickerId) => {
  return new Promise((resolve) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    // Custom DELETE request without body
    fetch(`${BASE_URL}/admin/delete-stickers?id=${stickerId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data) {
        resolve(data);
      } else {
        resolve({ statusCode: "50000", message: 'Failed to delete sticker' });
      }
    })
    .catch(error => {
      console.error('API Error:', error);
      resolve({ statusCode: "50000", message: 'Failed to delete sticker' });
    });
  });
};